const storageKey = (uid: string) => `duvpost.displayNameOnboardingDone.v1:${uid}`;

/** Local reminder that this account already confirmed a display name on this browser. */
export function readDisplayNameOnboardingDoneCache(uid: string): boolean {
  if (!uid) return false;
  try {
    return localStorage.getItem(storageKey(uid)) === '1';
  } catch {
    return false;
  }
}

export function writeDisplayNameOnboardingDoneCache(uid: string): void {
  if (!uid) return;
  try {
    localStorage.setItem(storageKey(uid), '1');
  } catch {
    /* private mode */
  }
}
